import { AccessorFn } from '@tanstack/react-table'

import KnownTranslatorKeys from '../../localization/knownTranslatorKeys'

export enum BasicDataKeys {
  ID = 'id',
  CHECKBOX = 'checkbox',
}

export type ILWFCCategory = {
  categoryId: string
  categoryLabel: string
  colorCategoryId?: string
  isChecked: boolean
  isPartialChecked?: boolean
  shortCategoryLabel?: string
  countLabel?: string
  instancesInfo?: string
  idsToSelect?: string[]
}

export type LWFCRowData = { [key: string]: any }

export interface ILWFCRow {
  category?: ILWFCCategory
  data: LWFCRowData
  height?: number
  level?: number
}

export interface ILWFCColumn {
  dataKey: string
  label?: string
  width?: number
  isMonospace?: boolean
  translatorKey?: KnownTranslatorKeys
  sectionName?: string
  isHidden?: boolean
  isFixed?: boolean
  flexGrow?: number
  accessorFn?: AccessorFn<any>
}
